import { AUTH_PREFIX } from 'src/clients';

export const GET_B2X_PERMISSION_ROLES_URL = `${AUTH_PREFIX}/permission/product-role`;

export enum B2xPermissionDetail {
  APPROVER = 'APPROVER',
  EDITOR = 'EDITOR',
  MAKER = 'MAKER',
  VIEWER = 'VIEWER',
}

export enum B2xPermissionProducts {
  ACCOUNT_PAYABLE = 'ACCOUNT_PAYABLE',
  ADD_PRODUCT = 'ADD_PRODUCT',
  API_DISBURSEMENT = 'API_DISBURSEMENT',
  API_OFFLINE_CASH_IN_DASHBOARD = 'API_OFFLINE_CASH_IN_DASHBOARD',
  AUTO_REPORT = 'AUTO_REPORT',
  AUTO_WITHDRAWAL = 'AUTO_WITHDRAWAL',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  BULK_DISBURSEMENT = 'BULK_DISBURSEMENT',
  B2X_USER_ACTIVITY_LOGS = 'B2X_USER_ACTIVITY_LOGS',
  BUSINESS_PROFILE = 'BUSINESS_PROFILE',
  CASH_DELIVERY_DASHBOARD = 'CASH_DELIVERY_DASHBOARD',
  CLAIM_FUND = 'CLAIM_FUND',
  DEVELOPER_OPTION = 'DEVELOPER_OPTION',
  EMAIL_NOTIFICATION = 'EMAIL_NOTIFICATION',
  MULTI_ACCOUNT_MANAGEMENT = 'MULTI_ACCOUNT_MANAGEMENT',
  MULTI_APPROVAL = 'MULTI_APPROVAL',
  PAYMENT_LINK = 'PAYMENT_LINK',
  PAYMENT_METHOD_REQUEST = 'PAYMENT_METHOD_REQUEST',
  TRANSACTION_CATEGORY = 'TRANSACTION_CATEGORY',
  UPGRADE_ACCOUNT = 'UPGRADE_ACCOUNT',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  INTERNATIONAL_TRANSFER = 'INTERNATIONAL_TRANSFER',
}
